<div id="status" *ngIf="!loaded && !error">
  <div class="spinner">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<!-- Mostrar errores si hay un problema con "financiero" -->
<div *ngIf="error && caso.financiero_descripcion && caso.financiero_descripcion.length > 0" class="alert alert-danger">
  Error al cargar los datos:
  <ul>
    <li *ngFor="let err of caso.financiero_descripcion">{{ err }}</li>
  </ul>
</div>

<h4 *ngIf="loaded && !error" i18n>I. CUANTÍA EN DISPUTA</h4>

<div>
  <!-- Tabla original de Cuantía en Disputa -->
  <table class="small-table-bordered" *ngIf="loaded && !error"
    style="width: auto; display: inline-block; vertical-align: top;">
    <tbody>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>Demanda</span></td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">{{
          getFormattedValue(caso.cuantia_demanda) }}</td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>Reconvención</span></td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">{{
          getFormattedValue(caso.cuantia_reconvencion) }}</td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>Tipo Tribunal</span></td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">{{
          caso.tipo_tribunal.replace('_', ' ') }}</td>
      </tr>
      <!-- Nueva fila para el campo calculadora -->
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>Calculadora</span></td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">{{ caso.calculadora }}
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Nueva tabla a la derecha con Total Provisión y Total Liquidación -->
  <table class="small-table-bordered" *ngIf="loaded && !error"
    style="width: auto; display: inline-block; vertical-align: top; margin-left: 20px;">
    <tbody>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>TOTALES</span></td>
        <td style="border-top: none !important;border-bottom: none !important;border-right: none !important;"></td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>Provisión de fondos</span></td>
        <td class="text-end color-cuantias total" style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.totalProvision) }}
        </td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>Liquidación</span></td>
        <td class="text-end color-cuantias total" style="vertical-align: middle; line-height: 1.5;" [ngClass]="{
            'text-danger': caso.financiero.totalLiquidacion < 0,
            'text-success': caso.financiero.totalLiquidacion >= 0
          }">
          {{ addLiquidado(getFormattedValue(caso.financiero.totalLiquidacion)) }}
        </td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;">
          <ng-container *ngIf="shouldShowReconvencion(); else liquidacionDemandantesDefault">
            <span i18n>Liquidación demandantes</span>
          </ng-container>
          <ng-template #liquidacionDemandantesDefault>
            <span i18n>Liquidación demandantes</span>
          </ng-template>
        </td>
        <td class="text-end color-cuantias total" style="vertical-align: middle; line-height: 1.5;" [ngClass]="{
            'text-danger': caso.financiero.totalLiquidacionDemandantes < 0,
            'text-success': caso.financiero.totalLiquidacionDemandantes >= 0
          }">
          {{ addLiquidado(getFormattedValue(caso.financiero.totalLiquidacionDemandantes)) }}
        </td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;">
          <ng-container *ngIf="shouldShowReconvencion(); else liquidacionDemandadosDefault">
            <span i18n>Liquidación demandados</span>
          </ng-container>
          <ng-template #liquidacionDemandadosDefault>
            <span i18n>Liquidación demandados</span>
          </ng-template>
        </td>
        <td class="text-end color-cuantias total" style="vertical-align: middle; line-height: 1.5;" [ngClass]="{
            'text-danger': caso.financiero.totalLiquidacionDemandados < 0,
            'text-success': caso.financiero.totalLiquidacionDemandados >= 0
          }">
          {{ addLiquidado(getFormattedValue(caso.financiero.totalLiquidacionDemandados)) }}
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Nueva tabla honorarios-->
  <table class="small-table-bordered" *ngIf="loaded && !error && caso?.tipo_tribunal==='TRIBUNAL_ARBITRAL'"
    style="width: auto; display: inline-block; vertical-align: top; margin-left: 20px;">
    <thead>
      <tr>
        <td class="small-table-header" style="text-align: center; vertical-align: middle; line-height: 1.5;"><span i18n>Honorarios NETOS</span></td>
        <td class="small-table-header" style="text-align: center; vertical-align: middle; line-height: 1.5;"><span i18n>DEMANDA</span>
        </td>
        <td *ngIf="shouldShowReconvencion()" class="small-table-header"
          style="text-align: center; vertical-align: middle; line-height: 1.5;"><span i18n>RECONVENCIÓN</span></td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;"><span i18n>
            Presidente</span><br>{{ getArbitroRolNombre('PRESIDENTE') }}</td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.demanda.honorarios_presidente) }}
        </td>
        <td *ngIf="shouldShowReconvencion()" class="text-end color-cuantias"
          style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.reconvencion.honorarios_presidente) }}
        </td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;">
          <ng-container *ngIf="shouldShowReconvencion(); else coarbitroDemandanteDefault">
            <span i18n>Co-árbitro demandante</span>
          </ng-container>
          <ng-template #coarbitroDemandanteDefault>
            <span i18n>Co-árbitro demandante</span>
          </ng-template>
          <span class="arbitro-nombre">{{ getArbitroRolNombre('COARBITRO_1') }}</span>
        </td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.demanda.honorarios_coarbitro_1) }}
        </td>
        <td *ngIf="shouldShowReconvencion()" class="text-end color-cuantias"
          style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.reconvencion.honorarios_coarbitro_1) }}
        </td>
      </tr>
      <tr>
        <td class="small-table-header" style="vertical-align: middle; line-height: 1.5;">
          <ng-container *ngIf="shouldShowReconvencion(); else coarbitroDemandadoDefault">
            <span i18n>Co-árbitro demandado</span>
          </ng-container>
          <ng-template #coarbitroDemandadoDefault>
            <span i18n>Co-árbitro demandado</span>
          </ng-template>
          <span class="arbitro-nombre">{{ getArbitroRolNombre('COARBITRO_2') }}</span>
        </td>
        <td class="text-end color-cuantias" style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.demanda.honorarios_coarbitro_2) }}
        </td>
        <td *ngIf="shouldShowReconvencion()" class="text-end color-cuantias"
          style="vertical-align: middle; line-height: 1.5;">
          {{ getFormattedValue(caso.financiero.reconvencion.honorarios_coarbitro_2) }}
        </td>
      </tr>
    </tbody>
  </table>



</div>





<h4 *ngIf="loaded && !error" i18n>II. COSTES DEL ARBITRAJE – DEMANDA</h4>

<div class="tabla-contenedor" *ngIf="loaded && !error">
  <div class="tabla-duo">
    <!-- Tabla fusionada de Provisión de Fondos y Liquidación -->
    <table class="table table-bordered tabla-provision-liquidacion">
      <thead>
        <!-- Primera fila: Cabeceras de Provisión de Fondos y Liquidación -->
        <tr>
          <th class="no-border"></th>
          <th [attr.colspan]="demandantesColspan + demandadosColspan" class="text-center"><span i18n>PROVISIÓN DE FONDOS</span></th>
          <th class="no-border no-background"></th> <!-- Columna de separación -->
          <th [attr.colspan]="demandantesColspan + demandadosColspan" class="text-center"><span i18n>LIQUIDACIÓN</span></th>
        </tr>

        <!-- Segunda fila: Cabeceras de Demandantes y Demandados -->
        <tr>
          <th class="no-border"></th>
          <th [attr.colspan]="demandantesColspan" class="text-center partes-header demandantes-header demandantes-bg">
            <span i18n>DEMANDANTES</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{ formatPercentage(caso.porcentaje_pago_demandantes_demanda) }}%)</span>
          </th>
          <th [attr.colspan]="demandadosColspan" class="text-center partes-header demandados-header demandados-bg">
            <span i18n>DEMANDADOS</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{
              formatPercentage(caso.porcentaje_pago_demandados_demanda) }}%)</span>
          </th>
          <th class="no-border no-background"> <!-- Columna de separación -->
          <th [attr.colspan]="demandantesColspan" class="text-center partes-header demandantes-header demandantes-bg">
            <span i18n>DEMANDANTES</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{ formatPercentage(caso.porcentaje_pago_demandantes_demanda) }}%)</span>
          </th>
          <th [attr.colspan]="demandadosColspan" class="text-center partes-header demandados-header demandados-bg">
            <span i18n>DEMANDADOS</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{
              formatPercentage(caso.porcentaje_pago_demandados_demanda) }}%)</span>
          </th>
        </tr>
        <tr>
          <th class="no-border"></th>
          <th *ngFor="let d of filteredDemandantes"
            class="text-center small-text partes-header demandantes-header demandantes-bg">
           <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredDemandantes.length > 1"
            class="text-center partes-header demandantes-header demandantes-bg">
            TOTAL
          </th>
          <th *ngFor="let d of filteredDemandados"
            class="text-center small-text partes-header demandados-header demandados-bg">
            <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredDemandados.length > 1" class="text-center partes-header demandados-header demandados-bg">
            TOTAL
          </th>
          <th class="no-border no-background"></th> <!-- Columna de separación -->
          <th *ngFor="let d of filteredDemandantes"
            class="text-center small-text partes-header demandantes-header demandantes-bg">
            <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredDemandantes.length > 1"
            class="text-center partes-header demandantes-header demandantes-bg">
            TOTAL
          </th>
          <th *ngFor="let d of filteredDemandados"
            class="text-center small-text partes-header demandados-header demandados-bg">
            <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredDemandados.length > 1" class="text-center partes-header demandados-header demandados-bg">
            TOTAL
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let section of sections">
          <!-- Fila vacía antes de cada sección -->
          <tr class="empty-row empty-row-high">
            <td colspan="100%" class="no-border no-background"></td>
          </tr>

          <!-- Cabecera de sección -->
          <tr>
            <td></td>
            <td [attr.colspan]="demandantesColspan + demandadosColspan" class="section-header"
              [ngStyle]="{
    'background-color': (section === 'Honorarios de los árbitros' || section === 'Derechos de administración' || section === 'Gastos del expediente') ? '#E6A895' : ''}">
              {{ translate(section) }}
              <ng-container *ngIf="section === 'Derechos de administración'">
                ({{ caso.porcentaje_derecho_administracion_demanda }}%)
              </ng-container>
              <ng-container *ngIf="section === 'Honorarios de los árbitros'">
                ({{ caso.porcentaje_honorario_arbitro_demanda }}%)
              </ng-container>
            </td>
            <td class="no-border no-background" style="border-right: none !important;"></td>
            <td [attr.colspan]="demandantesColspan + demandadosColspan" class="section-header"
              [ngClass]="{'no-border no-background': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}" [ngStyle]="{
    'background-color': (section === 'Honorarios, derechos y gastos' || section === 'Gastos del expediente') ? '#E6A895' : '',
    'border': section === 'Honorarios de los árbitros' || section === 'Derechos de administración' ? 'none' : ''
  }">
              <ng-container *ngIf="section === 'Gastos del expediente'; else honorariosSection">
                <span i18n>Honorarios, derechos y gastos</span>
              </ng-container>
              <ng-template #honorariosSection>
                <ng-container *ngIf="section !== 'Honorarios de los árbitros' && section !== 'Derechos de administración'">{{ translate(section) }}</ng-container>
              </ng-template>
            </td>
          </tr>



          <!-- Fila para "Neto", "IVA" y "Total" en Provisión -->
          <tr *ngFor="let row of (section === 'Gastos de los árbitros' ? ['Total'] : ['Neto', 'IVA', 'Total'])">
            <td class="text-end filas-encabezados section-text">{{ row }}</td>

            <!-- Provisión: Demandantes -->
            <td *ngFor="let d of filteredDemandantes" class="no-wrap text-end demandantes-field demandantes-bg"
              [ngClass]="{'total': row === 'Total'}">
              <ng-container *ngIf="row === 'IVA' && section === 'Alquiler de salas' && getValue(d, section, row)">
                ({{ caso.impuesto_aplicable_general }}%) {{ getValue(d, section, row) }}
              </ng-container>
              <ng-container *ngIf="row === 'IVA' && section !== 'Alquiler de salas' && getValue(d, section, row)">
                ({{ d.impuesto_aplicable }}%) {{ getValue(d, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getValue(d, section, row) }}
              </ng-container>
            </td>
            <td *ngIf="filteredDemandantes.length > 1" class="no-wrap text-end demandantes-field demandantes-bg total">
              <ng-container *ngIf="row === 'IVA' && section === 'Alquiler de salas'">
                ({{ caso.impuesto_aplicable_general }}%) {{ getTotalValue(demandantesTotal.total, section, row) }}
              </ng-container>
              <ng-container *ngIf="row === 'IVA' && section !== 'Alquiler de salas'">
                {{ demandantesTotal.total.impuesto_aplicable }} {{ getTotalValue(demandantesTotal.total, section, row)
                }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getTotalValue(demandantesTotal.total, section, row) }}
              </ng-container>
            </td>

            <!-- Provisión: Demandados -->
            <td *ngFor="let d of filteredDemandados" class="no-wrap text-end demandados-field demandados-bg"
              [ngClass]="{'total': row === 'Total'}">
              <ng-container *ngIf="row === 'IVA' && section === 'Alquiler de salas' && getValue(d, section, row)">
                ({{ caso.impuesto_aplicable_general }}%) {{ getValue(d, section, row) }}
              </ng-container>
              <ng-container *ngIf="row === 'IVA' && section !== 'Alquiler de salas' && getValue(d, section, row)">
                ({{ d.impuesto_aplicable }}%) {{ getValue(d, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getValue(d, section, row) }}
              </ng-container>
            </td>
            <td *ngIf="filteredDemandados.length > 1" class="no-wrap text-end demandados-field demandados-bg total">
              <ng-container *ngIf="row === 'IVA' && section === 'Alquiler de salas'">
                ({{ caso.impuesto_aplicable_general }}%) {{ getTotalValue(demandadosTotal.total, section, row) }}
              </ng-container>
              <ng-container *ngIf="row === 'IVA' && section !== 'Alquiler de salas'">
                {{ getTotalValue(demandadosTotal.total, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getTotalValue(demandadosTotal.total, section, row) }}
              </ng-container>
            </td>

            <td class="no-border no-background" style="border-right: none;"></td> <!-- Columna de separación -->

            <!-- Liquidación: Demandantes -->
            <td *ngFor="let d of filteredLiquidacionDemandantes"
              class="no-wrap text-end demandantes-field demandantes-bg total" [ngClass]="{
            'text-danger': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) === '-', 
            'text-success': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) !== '-',
            'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
              <ng-container *ngIf="section !== 'Honorarios de los árbitros' && section !== 'Derechos de administración' && row === 'Total'; else emptyCell">
                {{ addLiquidado(getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
              </ng-container>
            </td>

            <td *ngIf="filteredLiquidacionDemandantes.length > 1"
              class="no-wrap text-end demandantes-field demandantes-bg total" [ngClass]="{
            'text-danger': getTotalValue(liquidacionDemandantesTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) === '-', 
            'text-success': getTotalValue(liquidacionDemandantesTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) !== '-',
            'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
              {{ addLiquidado(getTotalValue(liquidacionDemandantesTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
            </td>

            <!-- Liquidación: Demandados -->
            <td *ngFor="let d of filteredLiquidacionDemandados"
              class="no-wrap text-end demandados-field demandados-bg total" [ngClass]="{
            'text-danger': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) === '-', 
            'text-success': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) !== '-',
            'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
              <ng-container *ngIf="section !== 'Honorarios de los árbitros' && section !== 'Derechos de administración' && row === 'Total'; else emptyCell">
                {{ addLiquidado(getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
              </ng-container>
            </td>

            <td *ngIf="filteredLiquidacionDemandados.length > 1"
              class="no-wrap text-end demandados-field demandados-bg total" [ngClass]="{
            'text-danger': getTotalValue(liquidacionDemandadosTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) === '-', 
            'text-success': getTotalValue(liquidacionDemandadosTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) !== '-',
            'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
              {{ addLiquidado(getTotalValue(liquidacionDemandadosTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
            </td>

            <ng-template #emptyCell>
              <!-- Celdas vacías para los campos Neto e IVA en la parte de Liquidación -->
              <ng-container *ngIf="row === 'Neto' || row === 'IVA'"></ng-container>
            </ng-template>
          </tr>


        </ng-container>


        <!-- Nueva sección Totales -->
        <tr class="empty-row empty-row-high">
          <td colspan="100%" class="no-border no-background"></td>
        </tr>
        <tr>
          <td class="no-border no-background"></td>
          <td [attr.colspan]="demandantesColspan + demandadosColspan" class="section-header"><span i18n>TOTALES</span></td>
          <td class="no-border"></td>
          <td [attr.colspan]="demandantesColspan + demandadosColspan" class="section-header"><span i18n>TOTALES</span></td>
        </tr>
        <tr>
          <td class="no-border no-background"></td>

          <!-- Totales: Provisión Demandantes -->
          <td *ngFor="let d of filteredDemandantes" class="no-wrap text-end demandantes-field demandantes-bg total">
            {{ getFormattedValue(d.sumatorioTotales) }}
          </td>
          <td *ngIf="filteredDemandantes.length > 1" class="no-wrap text-end demandantes-field demandantes-bg total">
            {{ getFormattedValue(demandantesTotal.total.sumatorioTotales) }}
          </td>

          <!-- Totales: Provisión Demandados -->
          <td *ngFor="let d of filteredDemandados" class="no-wrap text-end demandados-field demandados-bg total">
            {{ getFormattedValue(d.sumatorioTotales) }}
          </td>
          <td *ngIf="filteredDemandados.length > 1" class="no-wrap text-end demandados-field demandados-bg total">
            {{ getFormattedValue(demandadosTotal.total.sumatorioTotales) }}
          </td>

          <td class="no-border"></td> <!-- Columna de separación -->

          <!-- Totales: Liquidación Demandantes -->
          <td *ngFor="let d of filteredLiquidacionDemandantes"
            class="no-wrap text-end demandantes-field demandantes-bg total"
            [ngClass]="{'text-danger': d.sumatorioTotales < 0, 'text-success': d.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(d.sumatorioTotales)) }}
          </td>
          <td *ngIf="filteredLiquidacionDemandantes.length > 1"
            class="no-wrap text-end demandantes-field demandantes-bg total"
            [ngClass]="{'text-danger': liquidacionDemandantesTotal.total.sumatorioTotales < 0, 'text-success': liquidacionDemandantesTotal.total.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(liquidacionDemandantesTotal.total.sumatorioTotales)) }}
          </td>

          <!-- Totales: Liquidación Demandados -->
          <td *ngFor="let d of filteredLiquidacionDemandados"
            class="no-wrap text-end demandados-field demandados-bg total"
            [ngClass]="{'text-danger': d.sumatorioTotales < 0, 'text-success': d.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(d.sumatorioTotales)) }}
          </td>
          <td *ngIf="filteredLiquidacionDemandados.length > 1"
            class="no-wrap text-end demandados-field demandados-bg total"
            [ngClass]="{'text-danger': liquidacionDemandadosTotal.total.sumatorioTotales < 0, 'text-success': liquidacionDemandadosTotal.total.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(liquidacionDemandadosTotal.total.sumatorioTotales)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>



<!-- Tabla III para Reconvención -->
<h4 *ngIf="shouldShowReconvencion() && loaded && !error" i18n>III. COSTES DEL ARBITRAJE – RECONVENCIÓN</h4>

<div class="tabla-contenedor" *ngIf="shouldShowReconvencion() && loaded && !error">
  <div class="tabla-duo">
    <!-- Tabla fusionada de Provisión de Fondos y Liquidación -->
    <table class="table table-bordered tabla-provision-liquidacion">
      <thead>
        <!-- Primera fila: Cabeceras de Provisión de Fondos y Liquidación -->
        <tr>
          <th class="no-border"></th>
          <th [attr.colspan]="reconvencionDemandantesColspan + reconvencionDemandadosColspan" class="text-center">
            <span i18n>PROVISIÓN DE FONDOS</span>
          </th>
          <th class="no-border no-background"></th> <!-- Columna de separación -->
          <th [attr.colspan]="reconvencionDemandantesColspan + reconvencionDemandadosColspan" class="text-center">
            <span i18n>LIQUIDACIÓN</span>
          </th>
        </tr>

        <!-- Segunda fila: Cabeceras de Demandantes y Demandados -->
        <tr>
          <th class="no-border"></th>
          <th [attr.colspan]="reconvencionDemandantesColspan"
            class="text-center partes-header demandantes-header demandantes-bg">
            <span i18n>DEMANDANTES</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{ formatPercentage(caso.porcentaje_pago_demandantes_reconvencion) }}%)</span>
          </th>
          <th [attr.colspan]="reconvencionDemandadosColspan"
            class="text-center partes-header demandados-header demandados-bg">
            <span i18n>DEMANDADOS</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{ formatPercentage(caso.porcentaje_pago_demandados_reconvencion) }}%)</span>
          </th>
          <th class="no-border no-background"></th> <!-- Columna de separación -->
          <th [attr.colspan]="reconvencionDemandantesColspan"
            class="text-center partes-header demandantes-header demandantes-bg">
            <span i18n>DEMANDANTES</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{ formatPercentage(caso.porcentaje_pago_demandantes_reconvencion) }}%)</span>
          </th>
          <th [attr.colspan]="reconvencionDemandadosColspan"
            class="text-center partes-header demandados-header demandados-bg">
            <span i18n>DEMANDADOS</span>
            <br>
            <span style="font-weight: normal;"><span i18n>% imputable</span> ({{ formatPercentage(caso.porcentaje_pago_demandados_reconvencion) }}%)</span>
          </th>
        </tr>
        <tr>
          <th class="no-border"></th>
          <th *ngFor="let d of filteredReconvencionDemandantes"
            class="text-center small-text partes-header demandantes-header demandantes-bg">
            <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredReconvencionDemandantes.length > 1"
            class="text-center partes-header demandantes-header demandantes-bg">
            TOTAL
          </th>
          <th *ngFor="let d of filteredReconvencionDemandados"
            class="text-center small-text partes-header demandados-header demandados-bg">
            <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredReconvencionDemandados.length > 1"
            class="text-center partes-header demandados-header demandados-bg">
            TOTAL
          </th>
          <th class="no-border no-background"></th> <!-- Columna de separación -->
          <th *ngFor="let d of filteredReconvencionDemandantes"
            class="text-center small-text partes-header demandantes-header demandantes-bg">
            <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredReconvencionDemandantes.length > 1"
            class="text-center partes-header demandantes-header demandantes-bg">
            TOTAL
          </th>
          <th *ngFor="let d of filteredReconvencionDemandados"
            class="text-center small-text partes-header demandados-header demandados-bg">
           <div class="partes-header-content">
              <div class="parte-nombre" [title]="d.parte">{{ d.parte }}</div>
              <div class="partes-header-body">
                <div class="parte-porcentaje" style="font-weight: normal;">
                  <span i18n>% imputable</span> ({{ formatPercentage(d.porcentaje_imputable) }}%)
                </div>
                <hr class="partes-header-divider">
                <div class="parte-final" style="display: inline-block; font-weight: normal;">
                  <span i18n>% final</span> ({{ formatPercentage(d.porcentaje_final_aplicado) }}%)
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="filteredReconvencionDemandados.length > 1"
            class="text-center partes-header demandados-header demandados-bg">
            TOTAL
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let section of sections">
          <!-- Fila vacía antes de cada sección -->
          <tr class="empty-row empty-row-high">
            <td colspan="100%" class="no-border no-background"></td>
          </tr>

          <!-- Cabecera de sección -->
          <tr>
            <td></td>
            <td [attr.colspan]="reconvencionDemandantesColspan + reconvencionDemandadosColspan" class="section-header"
              [ngStyle]="{
                'background-color': (section === 'Honorarios de los árbitros' || section === 'Derechos de administración' || section === 'Gastos del expediente') ? '#E6A895' : ''}">
              {{ translate(section) }}
              <ng-container *ngIf="section === 'Derechos de administración'">
                ({{ caso.porcentaje_derecho_administracion_reconvencion }}%)
              </ng-container>
              <ng-container *ngIf="section === 'Honorarios de los árbitros'">
                ({{ caso.porcentaje_honorario_arbitro_reconvencion }}%)
              </ng-container>
            </td>
            <td class="no-border no-background" style="border-right: none !important;"></td>
            <td [attr.colspan]="reconvencionDemandantesColspan + reconvencionDemandadosColspan" class="section-header"
              [ngClass]="{'no-border no-background': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}" [ngStyle]="{
                'background-color': (section === 'Honorarios, derechos y gastos' || section === 'Gastos del expediente') ? '#E6A895' : '',
                'border': section === 'Honorarios de los árbitros' || section === 'Derechos de administración' ? 'none' : ''
              }">
              <ng-container *ngIf="section === 'Gastos del expediente'; else honorariosSection">
                <span i18n>Honorarios, derechos y gastos</span>
              </ng-container>
              <ng-template #honorariosSection>
                <ng-container *ngIf="section !== 'Honorarios de los árbitros' && section !== 'Derechos de administración'">{{ translate(section) }}</ng-container>
              </ng-template>
            </td>
          </tr>

          <!-- Fila para "Neto", "IVA" y "Total" en Provisión -->
          <tr *ngFor="let row of (section === 'Gastos de los árbitros' ? ['Total'] : ['Neto', 'IVA', 'Total'])">
            <td class="text-end filas-encabezados section-text">{{ row }}</td>

            <!-- Provisión: Demandantes -->
            <td *ngFor="let d of filteredReconvencionDemandantes"
              class="no-wrap text-end demandantes-field demandantes-bg" [ngClass]="{'total': row === 'Total'}">
              <ng-container
                *ngIf="row === 'IVA' && section === 'Alquiler de salas' && getReconvencionValue(d, section, row)">
                ({{ caso.impuesto_aplicable_general }}%) {{ getReconvencionValue(d, section, row) }}
              </ng-container>
              <ng-container
                *ngIf="row === 'IVA' && section !== 'Alquiler de salas' && getReconvencionValue(d, section, row)">
                ({{ d.impuesto_aplicable }}%) {{ getReconvencionValue(d, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getReconvencionValue(d, section, row) }}
              </ng-container>
            </td>
            <td *ngIf="filteredReconvencionDemandantes.length > 1"
              class="no-wrap text-end demandantes-field demandantes-bg total">
              <ng-container *ngIf="row === 'IVA' && section === 'Alquiler de salas'">
                ({{ caso.impuesto_aplicable_general }}%) {{
                getTotalReconvencionValue(reconvencionDemandantesTotal.total, section, row) }}
              </ng-container>
              <ng-container *ngIf="row === 'IVA' && section !== 'Alquiler de salas'">
                {{ getTotalReconvencionValue(reconvencionDemandantesTotal.total, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getTotalReconvencionValue(reconvencionDemandantesTotal.total, section, row) }}
              </ng-container>
            </td>

            <!-- Provisión: Demandados -->
            <td *ngFor="let d of filteredReconvencionDemandados" class="no-wrap text-end demandados-field demandados-bg"
              [ngClass]="{'total': row === 'Total'}">
              <ng-container
                *ngIf="row === 'IVA' && section === 'Alquiler de salas' && getReconvencionValue(d, section, row)">
                ({{ caso.impuesto_aplicable_general }}%) {{ getReconvencionValue(d, section, row) }}
              </ng-container>
              <ng-container
                *ngIf="row === 'IVA' && section !== 'Alquiler de salas' && getReconvencionValue(d, section, row)">
                ({{ d.impuesto_aplicable }}%) {{ getReconvencionValue(d, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getReconvencionValue(d, section, row) }}
              </ng-container>
            </td>
            <td *ngIf="filteredReconvencionDemandados.length > 1"
              class="no-wrap text-end demandados-field demandados-bg total">
              <ng-container *ngIf="row === 'IVA' && section === 'Alquiler de salas'">
                ({{ caso.impuesto_aplicable_general }}%) {{ getTotalReconvencionValue(reconvencionDemandadosTotal.total,
                section, row) }}
              </ng-container>
              <ng-container *ngIf="row === 'IVA' && section !== 'Alquiler de salas'">
                {{ getTotalReconvencionValue(reconvencionDemandadosTotal.total, section, row) }}
              </ng-container>
              <ng-container *ngIf="row !== 'IVA'">
                {{ getTotalReconvencionValue(reconvencionDemandadosTotal.total, section, row) }}
              </ng-container>
            </td>

            <td class="no-border no-background" style="border-right: none;"></td> <!-- Columna de separación -->

            <!-- Liquidación: Demandantes -->
            <td *ngFor="let d of filteredReconvencionLiquidacionDemandantes"
            class="no-wrap text-end demandantes-field demandantes-bg total" [ngClass]="{
              'text-danger': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) === '-', 
              'text-success': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) !== '-',
              'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
                <ng-container *ngIf="section !== 'Honorarios de los árbitros' && section !== 'Derechos de administración' && row === 'Total'; else emptyCell">
                  {{ addLiquidado(getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
                </ng-container>
              </td>

            <td *ngIf="filteredReconvencionLiquidacionDemandantes.length > 1"
              class="no-wrap text-end demandantes-field demandantes-bg total" [ngClass]="{
                'text-danger': getTotalReconvencionValue(reconvencionLiquidacionDemandantesTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) === '-', 
                'text-success': getTotalReconvencionValue(reconvencionLiquidacionDemandantesTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) !== '-',
                'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
                  {{ addLiquidado(getTotalReconvencionValue(reconvencionLiquidacionDemandantesTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
                </td>

            <!-- Liquidación: Demandados -->
            <td *ngFor="let d of filteredReconvencionLiquidacionDemandados"
            class="no-wrap text-end demandados-field demandados-bg total" [ngClass]="{
              'text-danger': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) === '-', 
              'text-success': getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row).trim().charAt(0) !== '-',
              'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
                <ng-container *ngIf="section !== 'Honorarios de los árbitros' && section !== 'Derechos de administración' && row === 'Total'; else emptyCell">
                  {{ addLiquidado(getLiquidacionValue(d, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
                </ng-container>
              </td>

            <td *ngIf="filteredReconvencionLiquidacionDemandados.length > 1"
              class="no-wrap text-end demandados-field demandados-bg total" [ngClass]="{
                'text-danger': getTotalReconvencionValue(reconvencionLiquidacionDemandadosTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) === '-', 
                'text-success': getTotalReconvencionValue(reconvencionLiquidacionDemandadosTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, 'Total').trim().charAt(0) !== '-',
                'no-border-honorarios': section === 'Honorarios de los árbitros' || section === 'Derechos de administración'}">
                  {{ addLiquidado(getTotalReconvencionValue(reconvencionLiquidacionDemandadosTotal.total, section === 'Gastos del expediente' ? 'Honorarios, derechos y gastos' : section, row)) }}
                </td>

            <ng-template #emptyCell>
              <!-- Celdas vacías para los campos Neto e IVA en la parte de Liquidación -->
              <ng-container *ngIf="row === 'Neto' || row === 'IVA'"></ng-container>
            </ng-template>
          </tr>

        </ng-container>

        <!-- Nueva sección Totales -->
        <tr class="empty-row empty-row-high">
          <td colspan="100%" class="no-border no-background"></td>
        </tr>
        <tr>
          <td class="no-border no-background"></td>
          <td [attr.colspan]="reconvencionDemandantesColspan + reconvencionDemandadosColspan" class="section-header">
            <span i18n>TOTALES</span></td>
          <td class="no-border"></td>
          <td [attr.colspan]="reconvencionDemandantesColspan + reconvencionDemandadosColspan" class="section-header">
            <span i18n>TOTALES</span></td>
        </tr>
        <tr>
          <td class="no-border no-background"></td>

          <!-- Totales: Provisión Demandantes -->
          <td *ngFor="let d of filteredReconvencionDemandantes"
            class="no-wrap text-end demandantes-field demandantes-bg total">
            {{ getFormattedValue(d.sumatorioTotales) }}
          </td>
          <td *ngIf="filteredReconvencionDemandantes.length > 1"
            class="no-wrap text-end demandantes-field demandantes-bg total">
            {{ getFormattedValue(reconvencionDemandantesTotal.total.sumatorioTotales) }}
          </td>

          <!-- Totales: Provisión Demandados -->
          <td *ngFor="let d of filteredReconvencionDemandados"
            class="no-wrap text-end demandados-field demandados-bg total">
            {{ getFormattedValue(d.sumatorioTotales) }}
          </td>
          <td *ngIf="filteredReconvencionDemandados.length > 1"
            class="no-wrap text-end demandados-field demandados-bg total">
            {{ getFormattedValue(reconvencionDemandadosTotal.total.sumatorioTotales) }}
          </td>

          <td class="no-border"></td> <!-- Columna de separación -->

          <!-- Totales: Liquidación Demandantes -->
          <td *ngFor="let d of filteredReconvencionLiquidacionDemandantes"
            class="no-wrap text-end demandantes-field demandantes-bg total"
            [ngClass]="{'text-danger': d.sumatorioTotales < 0, 'text-success': d.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(d.sumatorioTotales)) }}
          </td>
          <td *ngIf="filteredReconvencionLiquidacionDemandantes.length > 1"
            class="no-wrap text-end demandantes-field demandantes-bg total"
            [ngClass]="{'text-danger': reconvencionLiquidacionDemandantesTotal.total.sumatorioTotales < 0, 'text-success': reconvencionLiquidacionDemandantesTotal.total.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(reconvencionLiquidacionDemandantesTotal.total.sumatorioTotales)) }}
          </td>

          <!-- Totales: Liquidación Demandados -->
          <td *ngFor="let d of filteredReconvencionLiquidacionDemandados"
            class="no-wrap text-end demandados-field demandados-bg total"
            [ngClass]="{'text-danger': d.sumatorioTotales < 0, 'text-success': d.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(d.sumatorioTotales)) }}
          </td>
          <td *ngIf="filteredReconvencionLiquidacionDemandados.length > 1"
            class="no-wrap text-end demandados-field demandados-bg total"
            [ngClass]="{'text-danger': reconvencionLiquidacionDemandadosTotal.total.sumatorioTotales < 0, 'text-success': reconvencionLiquidacionDemandadosTotal.total.sumatorioTotales >= 0}">
            {{ addLiquidado(getFormattedValue(reconvencionLiquidacionDemandadosTotal.total.sumatorioTotales)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
